module.exports = __webpack_public_path__ + "img/quick.6a4eebe3.png";